"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const bgImageAnimation = (0, styled_components_1.keyframes) `
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;
const DetailPageContainer = styled_components_1.default.div `
  animation: ${bgImageAnimation} ${(props) => props.fadeInContentAnimation * 1}s
    ease-in;

  &.hide {
    visibility: hidden;
  }

  z-index: 2;

  display: flex;
  align-items: flex-end;
  height: 100%;
  color: #fff;

  background-color: transparent;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-image: ${(props) => `url(${props.backgroundImage} )`};
  transition: background-image 3s;

  &.fullscreen-container {
    position: relative;
    padding: 0px 5vmin 11vmin;
    transform: scale(1.1);
    filter: blur(20px);
  }

  &.fullscreen-full-image {
    position: absolute;
    background-size: contain;
    width: 100%;
    top: 0;
  }
`;
const ENTER_TITLE_ANIMATION_TIME = 1 * 1000;
const ENTER_CONTENT_ANIMATION_TIME = 1 * 1000;
const HIDE_CONTENT_ANIMATION_TIME = 1 * 1000;
const FADE_OUT_TEXTS = 1 * 1000;
const FINAL_TITLE_DISPLAY_TIME = 1 * 1000;
const ImageOnlyPage = (props) => {
    const { content, openNextSlide, settings, setCurrentSlideDuration } = props;
    const slideDurationTimeout = (0, react_1.useRef)(null);
    const slideDuration = settings.fadeInContentTime +
        ENTER_TITLE_ANIMATION_TIME / settings.speed +
        ENTER_CONTENT_ANIMATION_TIME / settings.speed +
        settings.changeSlideInterval +
        HIDE_CONTENT_ANIMATION_TIME / settings.speed +
        FINAL_TITLE_DISPLAY_TIME / settings.speed +
        FADE_OUT_TEXTS / settings.speed;
    const openNextSlideAfterTimeout = () => {
        slideDurationTimeout.current = setTimeout(() => {
            if (!settings.stopSlideShow) {
                openNextSlide();
            }
        }, slideDuration);
    };
    (0, react_1.useEffect)(() => () => {
        clearTimeout(slideDurationTimeout.current);
    }, []);
    (0, react_1.useEffect)(() => {
        clearTimeout(slideDurationTimeout.current);
        setCurrentSlideDuration(slideDuration);
        openNextSlideAfterTimeout();
    }, [content]);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(DetailPageContainer, { fadeInContentAnimation: settings.fadeInContentTime / 1000, className: "fullscreen-container", backgroundImage: content.images[0] && content.images[0].original }),
        react_1.default.createElement(DetailPageContainer, { fadeInContentAnimation: settings.fadeInContentTime / 1000, className: "fullscreen-full-image", backgroundImage: content.images[0] && content.images[0].original })));
};
exports.default = ImageOnlyPage;
